export default "__VITE_ASSET__DjCVax8R__"